import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { TESTCASE } from '../../../../constants/applicationConstants';
import { DataTableHoc, Loader, ErrorFallback } from 'smart-react';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../../constants/applicationConstants';
import { deleteFilter, applyFilter, saveFilters } from 'smart-react';
const BaseDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable'),
);
const DataTable = DataTableHoc(BaseDataTable);

/**
 * TESTCASE main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The TESTCASE component.
 */
const TestCases = () => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className="container mx-auto">
        <React.Suspense fallback={<Loader />}>
          <DataTable
            deleteFilter={deleteFilter}
            applyFilter={applyFilter}
            saveFilters={saveFilters}
            moduleName={TESTCASE}
            dataColumns={dataColumnsArray}
            gridColumnsList={GridColumnsList}
            dataTableName={TESTCASE}
            setIsReady={setIsReady}
            isReady={isReady}
            rowLayoutConfigName={`${TESTCASE}.DataGrid.RowLayout`}
            pageLengthConfigName={`${TESTCASE}.DataGrid.ItemsPerPage`}
            dataSet={userData}
            setDataSet={setUserData}
            initialSort={{
              field: 'id',
              dir: 'desc',
            }}
            isCardonMobileView={false}
            total={process.env.DefaultLimit}
            defaultRowLayout={process.env.RowLayout}
            rowLayouts={ROW_LAYOUTS}
            pageSizes={PAGE_SIZE}
            isDefaultSlider={true}
            contentSliderTitle={'Test Case'}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default TestCases;
